import axios from 'axios';

export const FETCH_CART_REQUEST = 'FETCH_CART_REQUEST';
export const FETCH_CART_SUCCESS = 'FETCH_CART_SUCCESS';
export const FETCH_CART_FAILURE = 'FETCH_CART_FAILURE';
export const ADD_TO_CART_REQUEST = 'ADD_TO_CART_REQUEST';
export const ADD_TO_CART_SUCCESS = 'ADD_TO_CART_SUCCESS';
export const ADD_TO_CART_FAILURE = 'ADD_TO_CART_FAILURE';
export const REMOVE_FROM_CART_REQUEST = 'REMOVE_FROM_CART_REQUEST';
export const REMOVE_FROM_CART_SUCCESS = 'REMOVE_FROM_CART_SUCCESS';
export const REMOVE_FROM_CART_FAILURE = 'REMOVE_FROM_CART_FAILURE';
export const CLEAR_CART_REQUEST = 'CLEAR_CART_REQUEST';
export const CLEAR_CART_SUCCESS = 'CLEAR_CART_SUCCESS';
export const CLEAR_CART_FAILURE = 'REMOVE_FROM_CART_FAILURE';
export const TOGGLE_CART = 'TOGGLE_CART';
export const CLOSE_CART = 'CLOSE_CART';

export const toggleCart = () => {
  return{
    type: TOGGLE_CART
  };
};

export const closeCart = () => {
  return{
    type: CLOSE_CART
  };
};

export const fetchCartRequest = () => {
  return{
    type: FETCH_CART_REQUEST
  };
};

export const fetchCartSuccess = cart => {
  return {
    type: FETCH_CART_SUCCESS,
    cart,
  };
};
export const fetchCartFailure = error => {
  return {
    type: FETCH_CART_FAILURE,
    error
  };
};

export const fetchCart = () => {
  return dispatch => {
    dispatch(fetchCartRequest());
    return axios(`${apiBase}/akkurat/v1/cart`)
      .then(response => dispatch(fetchCartSuccess(response.data)));
  };
};

export const addToCartRequest = () => {
  return{
    type: ADD_TO_CART_REQUEST
  };
};

export const addToCartSuccess = cart => {
  return {
    type: ADD_TO_CART_SUCCESS,
    cart
  };
};
export const addToCartFailure = error => {
  return {
    type: ADD_TO_CART_FAILURE,
    error
  };
};

export const addToCart = productId => {
  return dispatch => {
    dispatch(addToCartRequest());
    return axios.post(`${apiBase}/akkurat/v1/cart`, {
        product: productId
      })
      .then(response => dispatch(addToCartSuccess(response.data)));
  };
};

export const removeFromCartRequest = () => {
  return{
    type: REMOVE_FROM_CART_REQUEST
  };
};

export const removeFromCartSuccess = cart => {
  return {
    type: REMOVE_FROM_CART_SUCCESS,
    cart
  };
};
export const removeFromCartFailure = error => {
  return {
    type: REMOVE_FROM_CART_FAILURE,
    error
  };
};

export const removeFromCart = variantId => {
  return dispatch => {
    dispatch(removeFromCartRequest());
    return axios.delete(`${apiBase}/akkurat/v1/cart`, {
        data: {
          variantId
        }
      })
      .then(response => dispatch(removeFromCartSuccess(response.data)));
  };
};

export const clearCartRequest = () => {
  return{
    type: CLEAR_CART_REQUEST
  };
};

export const clearCartSuccess = () => {
  return {
    type: CLEAR_CART_SUCCESS,
  };
};

export const clearCartFailure = error => {
  return {
    type: CLEAR_CART_FAILURE,
    error
  };
};

export const clearCart = () => {
  return dispatch => {
    dispatch(clearCartRequest());
    return axios.delete(`${apiBase}/akkurat/v1/cart`)
      .then(response => dispatch(clearCartSuccess()));
  };
};
